// Single source of truth for "is the current session an impersonation".
// The actor token + target context are written to sessionStorage by the
// admin-panel impersonate flow; menuBar.jsx renders the orange banner and
// the Exit button from the same key.
//
// Used by the sidebar (to hide admin-only nav) and AuthRoute (to bounce
// direct URL access to admin routes). Keep these two layers in lockstep —
// hiding the nav without the route guard lets a stale bookmark or pasted
// URL slip through.
export const IMPERSONATION_STORAGE_KEY = 'combird_impersonation';

export function isImpersonating() {
  try {
    return !!sessionStorage.getItem(IMPERSONATION_STORAGE_KEY);
  } catch {
    return false;
  }
}
